export const CARETEAMS_RECEIVED = 'CARETEAMS_RECEIVED'
